/**
 * DeleteDialog — Shared delete confirmation dialog for careflow, workflow, and escalation.
 *
 * Props:
 *   open      — dialog visibility
 *   onClose   — cancel callback
 *   onConfirm — confirm delete callback
 *   saving    — boolean, disables buttons while deleting
 *   title     — dialog heading (e.g. "Delete Careflow")
 *   message   — descriptive warning text
 */

const DeleteDialog = ({ open, onClose, onConfirm, saving, title, message }) => {
    if (!open) return null;

    return (
        <div
            className="dp-dialog-overlay"
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 10000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(0, 0, 0, 0.4)',
            }}
            onClick={onClose}
        >
            <div className="cf-delete-dialog" onClick={(e) => e.stopPropagation()}>
                <h3 className="cf-delete-dialog__title">{title}</h3>
                <p className="cf-delete-dialog__message">{message}</p>
                <div className="cf-delete-dialog__actions">
                    <button className="dp-btn dp-btn--cancel" onClick={onClose} disabled={saving}>
                        Cancel
                    </button>
                    <button className="dp-btn dp-btn--danger" onClick={onConfirm} disabled={saving}>
                        {saving ? 'Deleting...' : 'Delete'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteDialog;
